const ns = '[Property Menu] ';

export const ADD_LANE = `${ns}add a street lane/bike lane/shoulder etc.`;
export const SET_MEASUREMENT_POINTS_OPEN = `${ns}set measurement points modal status`;
export const SET_CSV_PREVIEW_OPEN = `${ns}set csv preview modal status`;
export const SET_CSV_DATA = `${ns}set csv data`;
